<template lang="pug">
app-page(:singleView="true")
  template(slot="content")
    v-card(
      v-if="parentSectionsFirst"
      ).parentCard
      v-container(
        fluid
        style="min-height: 0; padding-top:0px;"
        grid-list-xl
        class="vertical-divider"
      )
        v-layout(
          row
          v-if="isAllowedTo(1)"
          v-for="(item, index) in parentSectionList"
          :index="index"
          :key="index"
          :item="item"
        )
          v-flex(
          xs12
          v-show="(role >= item.editrole || !item.hidden)"
          ).showBox
              quicklinks-list(
              :sectionHeader="item.title"
              sectionHeaderColour="#696969"
              cardDefaultWidth="120px"
              cardFontSize="12px"
              :qlSet="item.tag"
              :editRole="5"
              :collapsed="item.collapsed ? item.collapsed : false"
              :id="item.id"
              :sectionLists="parentSectionList"
              :resultLists="item.resultLists"
              :quicklinks="item.quicklinks"
              :disableLists="item.disableLists"
              :isEditView="item.editState"
              :index="index"
              :sectionHidden="item.hidden"
              :organisation="parentSubdomain"
              )
    v-card(v-if="parentSectionsFirst")
      v-container(
        fluid
        style="min-height: 0; padding-top:0px;"
        grid-list-xl
        class="vertical-divider"
      )
        v-layout(
          row
          v-if="isAllowedTo(1)"
          v-for="(item, index) in currentSectionList"
          :index="index"
          :key="item.id"
          )
          v-flex(
            xs12
            v-show="(role >= item.editrole || !item.hidden)"
            ).showBox
            quicklinks-list(
            :sectionHeader="item.title"
            sectionHeaderColour="#696969"
            cardDefaultWidth="120px"
            cardFontSize="12px"
            :qlSet="item.tag"
            :editRole="item.editrole ? item.editrole : 2"
            :collapsed="item.collapsed ? item.collapsed : false"
            :id="item.id"
            :priority="item.priority"
            :sectionLists="sectionList"
            :currentSectionLists="currentSectionList"
            :resultLists="item.resultLists"
            :quicklinks="item.quicklinks"
            :disableLists="item.disableLists"
            :isEditView="item.editState"
            :index="index"
            :isMoveChange="item.isChange"
            :sectionTempName="item.sectionTempName"
            :sectionTempCollapsed="item.sectionTempCollapsed"
            :sectionHidden="item.hidden"
            :organisation="subdomain"
            @setResultList="setResultList"
            @setDisableList="setDisableList"
            @moveUpDown="moveUpDown"
            @editStateSave="editStateSave"
            @setSectionTempName="setSectionTempName"
            @setSectionTempCollapsed="setSectionTempCollapsed"
            @disableSection="disableSection"
            @deleteSection="deleteLinkSection"
            @restoreSection="restoreSection"
            @setSectionTitle="setSectionTitle"
            )
    v-card(v-if="!parentSectionsFirst")
      v-container(
        fluid
        style="min-height: 0; padding-top:0px;"
        grid-list-xl
        class="vertical-divider"
      )
        v-layout(
          row
          v-if="isAllowedTo(1)"
          v-for="(item, index) in currentSectionList"
          :index="index"
          :key="item.id"
          )
          v-flex(
            xs12
            v-show="(role >= item.editrole || !item.hidden)"
            ).showBox
            quicklinks-list(
            :sectionHeader="item.title"
            sectionHeaderColour="#696969"
            cardDefaultWidth="120px"
            cardFontSize="12px"
            :qlSet="item.tag"
            :editRole="item.editrole ? item.editrole : 2"
            :collapsed="item.collapsed ? item.collapsed : false"
            :id="item.id"
            :priority="item.priority"
            :sectionLists="sectionList"
            :currentSectionLists="currentSectionList"
            :resultLists="item.resultLists"
            :quicklinks="item.quicklinks"
            :disableLists="item.disableLists"
            :isEditView="item.editState"
            :index="index"
            :isMoveChange="item.isChange"
            :sectionTempName="item.sectionTempName"
            :sectionTempCollapsed="item.sectionTempCollapsed"
            :sectionHidden="item.hidden"
            :organisation="subdomain"
            @setResultList="setResultList"
            @setDisableList="setDisableList"
            @moveUpDown="moveUpDown"
            @editStateSave="editStateSave"
            @setSectionTempName="setSectionTempName"
            @setSectionTempCollapsed="setSectionTempCollapsed"
            @disableSection="disableSection"
            @deleteSection="deleteLinkSection"
            @restoreSection="restoreSection"
            @setSectionTitle="setSectionTitle"
            )
    v-card(v-if="!parentSectionsFirst").parentCard
      v-container(
        fluid
        style="min-height: 0; padding-top:0px;"
        grid-list-xl
        class="vertical-divider"
      )
        v-layout(
          row
          v-if="isAllowedTo(1)"
          v-for="(item, index) in parentSectionList"
          :index="index"
          :key="index"
          :item="item"
        )
          v-flex(
          xs12
          v-show="(role >= item.editrole || !item.hidden)"
          ).showBox
              quicklinks-list(
              :sectionHeader="item.title"
              sectionHeaderColour="#696969"
              cardDefaultWidth="120px"
              cardFontSize="12px"
              :qlSet="item.tag"
              :editRole="5"
              :collapsed="item.collapsed ? item.collapsed : false"
              :id="item.id"
              :sectionLists="parentSectionList"
              :resultLists="item.resultLists"
              :quicklinks="item.quicklinks"
              :disableLists="item.disableLists"
              :isEditView="item.editState"
              :index="index"
              :sectionHidden="item.hidden"
              :organisation="parentSubdomain"
              )
    div().addSectionButton
      v-btn(
        flat
        @click="addLinkSection"
        v-if="isAllowedTo(2)"
      ).addButton
        v-icon() add
        span() ADD SECTION
    add-section-module-dialog(
        :list = "currentSectionList"
        :show-dialog="showAddDialog"
        :organisation="subdomain"
        @closed="showAddDialog=false"
        @reloadSection="reloadSection"
        ref="childSection"
    )
    delete-section-module-dialog(
        :show-dialog="showDeleteSectionDialog"
        :index="deleteIndex"
        @closed="showDeleteSectionDialog=false"
        @deleteQuickLinkSection="deleteQuickLinkSection"
    )
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Base from '@/components/views/Base';
import { section, quicklink, client, settings } from '@/api';
import sortArray from '@/lib/sortArray';
import QuicklinksList from './QuicklinksList';
import AddSectionModuleDialog from './AddSectionModuleDialog';
import DeleteSectionModuleDialog from './DeleteSectionModuleDialog';

export default {
    name: 'Dashboard',

    extends: Base,

    components: {
        QuicklinksList,
        AddSectionModuleDialog,
        DeleteSectionModuleDialog
    },

    data() {
        return {
            showAddDialog: false,
            showAddParentDialog: false,
            parentSections: [],
            sectionList: [],
            currentItemIndexDelete: '',
            currentSectionList: [],
            parentSectionList: [],
            allSubdomains: {},
            isParent: false,
            showDivider: false,
            parentSubdomain: '',
            showDeleteSectionDialog: false,
            deleteIndex: 0,
            parentSectionsFirst: true,
        };
    },

    created() {
        this.setLoading(true);
        this.setViewTitle(this.$t('dashboard.title'));
        this.getSectionList();
        this.getSettings();
    },

    watch: {
        showAddDialog(value) {
            if (value) {
                this.disableScrollBar();
            } else {
                this.enableScrollBar();
            }
        },
        currentSectionList: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
            }
        }
    },

    computed: {
        ...mapGetters({
            isAllowedTo: 'session/isAllowedTo'
        }),

        ...mapState({
            role: state => state.session.role,
            subdomain: state => state.session.subdomain,
        }),
    },

    methods: {
        async getSectionList() {
            try {
                const clientResult = await client.getClient();
                if (clientResult.data.parentId !== null) {
                    this.isParent = true;
                    const response = await client.getClientParent();
                    this.parentSubdomain = response.data.subdomain;
                    this.allSubdomains.parent = response.data.subdomain;
                }
                this.allSubdomains.organisation = this.subdomain;
                this.sectionList = await this.getSectionsAndLinks(this.allSubdomains);
                this.currentSectionList = this.sectionList.filter(
                    item => item.organisation === this.subdomain);
                this.parentSectionList = this.sectionList.filter(
                    item => item.organisation === this.allSubdomains.parent);

                this.showDivider = true;
            } catch (err) {
                console.log(err);
            } finally {
                this.setLoading(false);
            }
        },

        async getSettings() {
            const settingsResult = await settings.getSettings();
            if (settingsResult && Array.isArray(settingsResult.data)) {
                const parentSectionFirstSettings = settingsResult.data.find(x => (x.settingName === 'parentSectionsFirst'));
                if (parentSectionFirstSettings) {
                    this.parentSectionsFirst = parentSectionFirstSettings.settingValue;
                }
            }
        },

        addLinkSection() {
            this.$refs.childSection.LoadCreateSection();
            this.showAddDialog = true;
        },

        deleteLinkSection(index) {
            this.deleteIndex = index;
            this.showDeleteSectionDialog = true;
        },

        addParentLinkSection() {
            this.$refs.parentSection.LoadCreateSection();
            this.showAddParentDialog = true;
        },

        async reloadSection(currentItem) {
            await sortArray.sortingArray(this.currentSectionList,
                currentItem, sortArray.actions.ADD, this.subdomain);
            this.setIsChangeFalse();
        },

        async deleteQuickLinkSection(index) {
            if (index < 0) return;
            this.setLoading(true);
            const updateList = [];

            try {
                if (this.currentSectionList.length === 0) return;
                const currentSection = this.currentSectionList[index];

                for (let i = index + 1; i < this.currentSectionList.length; i++) {
                    this.currentSectionList[i].priority--;
                    this.currentSectionList[i].isChange = true;
                }
                currentSection.hidden = true;
                currentSection.deleted = true;
                currentSection.priority = 0;
                currentSection.isChange = true;

                // Update database of deleted and priority of link sections
                await section.update(currentSection.id, {
                    organisation: this.subdomain,
                    priority: 0,
                    hidden: currentSection.hidden,
                    deleted: currentSection.deleted,
                    updated_at: new Date(),
                });

                for (let i = 0; i < this.currentSectionList.length; i++) {
                    if (this.currentSectionList[i].organisation
                        === this.subdomain && !this.currentSectionList[i].deleted) {
                        updateList.push({ id: this.currentSectionList[i].id,
                            priority: this.currentSectionList[i].priority });
                    }
                }
                if (updateList.length > 0) {
                    await section.updateSectionsPriority(updateList, this.subdomain);
                }
                this.$delete(this.currentSectionList, index);

                this.showSuccessAlert('Success.');
            } catch (err) {
                console.log(err);
            } finally {
                this.setLoading(false);
            }
        },

        setResultList(index, list) {
            this.currentSectionList[index].resultLists = list;
        },

        setDisableList(index, list) {
            this.currentSectionList[index].disableLists = list;
        },

        setSectionTempName(index, name) {
            this.currentSectionList[index].sectionTempName = name;
        },

        setSectionTitle(index, name) {
            this.currentSectionList[index].title = name;
        },

        setSectionTempCollapsed(index, collapsed) {
            this.currentSectionList[index].sectionTempCollapsed = collapsed;
        },

        setIsChangeFalse() {
            this.$nextTick(() => {
                for (let i = 0; i < this.currentSectionList.length; i++) {
                    this.currentSectionList[i].isChange = false;
                }
            });
        },

        async moveUpDown(index, action) {
            this.setLoading(true);
            try {
                const currentItem = this.currentSectionList[index];
                this.currentSectionList = await sortArray.sortingArray(
                    this.currentSectionList, currentItem, action, this.subdomain);
                this.currentSectionList[index].isChange = true;
                const consecutiveIndex = action === 'up' ? index - 1 : index + 1;
                this.currentSectionList[consecutiveIndex].isChange = true;
            } catch (err) {
                console.log(err);
            } finally {
                this.setIsChangeFalse();
                this.setLoading(false);
            }
        },

        editStateSave(index, state) {
            this.currentSectionList[index].editState = state;
        },

        disableScrollBar() {
            const mo = function disable(e) { e.preventDefault(); };
            document.body.style.overflow = 'hidden';
            document.addEventListener('touchmove', mo, false);
        },

        enableScrollBar() {
            const mo = function enable(e) { e.preventDefault(); };
            document.body.style.overflow = '';
            document.removeEventListener('touchmove', mo, false);
        },

        async disableSection(index) {
            this.setLoading(true);
            try {
                if (this.currentSectionList.length === 0) return;
                // Get the current section
                const currentSection = this.currentSectionList[index];
                // Get the first hidden section in the list
                const firstHiddenSectionIndex
                    = sortArray.findFirstHiddenIndex(this.currentSectionList);

                for (let i = firstHiddenSectionIndex - 1; i >= index; --i) {
                    this.currentSectionList[i].priority--;
                    this.currentSectionList[i].isChange = true;
                }

                // Set the current section to disabled
                currentSection.priority = firstHiddenSectionIndex;
                currentSection.hidden = true;
                currentSection.isChange = true;

                // Update database of disabled and priority of link sections
                await section.update(currentSection.id, {
                    organisation: this.subdomain,
                    priority: currentSection.priority,
                    hidden: currentSection.hidden,
                    updated_at: new Date(),
                });
                await sortArray.updateAllSectionPriority(this.currentSectionList, this.subdomain);
            } catch (err) {
                console.log(err);
            } finally {
                this.setIsChangeFalse();
                this.setLoading(false);
            }
        },

        async restoreSection(index) {
            this.setLoading(true);
            try {
                if (this.currentSectionList.length === 0) return;
                const currentSection = this.currentSectionList[index];

                const firstHiddenSectionIndex
                    = sortArray.findFirstHiddenIndex(this.currentSectionList);

                for (let i = firstHiddenSectionIndex; i < index; i++) {
                    this.currentSectionList[i].priority++;
                    this.currentSectionList[i].isChange = true;
                }
                currentSection.isChange = true;
                currentSection.hidden = false;
                currentSection.priority = firstHiddenSectionIndex + 1;
                const sectionItem = {
                    hidden: false,
                    organisation: this.subdomain,
                    updated_at: new Date(),
                    priority: currentSection.priority
                };

                await section.update(currentSection.id, sectionItem);
                await sortArray.updateAllSectionPriority(this.currentSectionList, this.subdomain);
            } catch (err) {
                console.log(err);
            } finally {
                this.setIsChangeFalse();
                this.setLoading(false);
            }
        },

        async getSectionsAndLinks(subdomain) {
            const response = await section.getSections(subdomain);
            const tempLists = response.data.localSections
            .concat(response.data.parentSections);
            const tags = [];
            for (let i = 0; i < tempLists.length; i++) {
                tempLists[i].resultLists = [];
                tempLists[i].editState = false;
                tempLists[i].isChange = false;
                tags.push(tempLists[i].tag);
            }
            const alllinks = await quicklink.getLinksByTags(subdomain, tags);
            if (alllinks.data.length > 0) {
                for (let i = 0; i < tempLists.length; i++) {
                    tempLists[i].quicklinks = alllinks.data.filter(
                        item => item.tags.indexOf(tempLists[i].tag) !== -1);
                }
            }
            return tempLists.sort((a, b) => {
                return a.priority - b.priority;
            });
        }
    }
};
</script>
<style scoped>
.addButton {
  background-color: var(--v-secondary-base);
  color: white;
}
.showBox {
  border: 1px solid rgba(0,0,0,.12);
}
.parentTitle {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
.addSectionButton {
  text-align: right;
  margin-bottom:  10px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/dashboard/Dashboard.vue